
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604125617589",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2328",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M792.021333 668.501333a411.434667 411.434667 0 0 1-278.4 107.392 411.434667 411.434667 0 0 1-277.973333-107.008c-130.389333 65.706667-215.978667 182.613333-215.978667 341.418667h991.317334c0-159.146667-87.168-276.181333-218.965334-341.802667M191.488 523.946667V271.786667a131.84 131.84 0 0 0-10.496 0.426666c57.173333-124.117333 184.533333-210.517333 332.672-210.517333 148.181333 0 275.498667 86.4 332.672 210.517333a131.498667 131.498667 0 0 0-10.496-0.426666v252.16c71.168 0 128.896-56.448 128.896-126.08a125.653333 125.653333 0 0 0-66.005333-110.08C843.349333 131.797333 692.096 19.712 513.706667 19.712c-178.346667 0-329.642667 112.085333-385.024 268.117333a125.653333 125.653333 0 0 0-66.005334 110.08c0 69.632 57.685333 126.08 128.853334 126.08m322.133333-377.984C359.552 145.962667 234.666667 268.245333 234.666667 419.114667c0 150.826667 124.885333 273.109333 278.954666 273.109333 154.112 0 278.997333-122.282667 278.997334-273.109333 0-150.869333-124.885333-273.152-278.997334-273.152",
        "p-id": "2329"
      }
    }
  ]
})
    }
  